// Permissions were required to be sorted in a specific order
/* eslint-disable perfectionist/sort-enums */
export enum AdminConfigPermissions {
  VIEW = 'VIEW_ADMIN_CONFIG',
  WRITE = 'WRITE_ADMIN_CONFIG',
  DELETE = 'DELETE_ADMIN_CONFIG',
}
